<template>
  <div class="body-container order-page">
    <div class="head-box">
      <div class="head-search-box">
        <div class="time-box" @click="$refs.datePanel.open()">
          <span>{{ startTime.replace(/-/g, "/") }} - {{ endTime.replace(/-/g, "/") }}</span>
          <i class="arr-icon"></i>
        </div> <img @click="goSearch" src="@static/images/search2.png" class="search-icon">
      </div>
      <van-tabs v-model="typeId" @change='clickTypeLevel2' class="list-tabs small">
        <van-tab :title="item.name" :name="item.id" v-for="(item) in typeList1" :key="item.id"></van-tab>
      </van-tabs>
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="info-box" v-if="list.length">
        <div class="money-row">
          <div class="num-box">共<span class="num">{{ ordersNum }}</span>单</div>
          <div class="money-box">
            <span class="label">保费：</span>
            <span v-if="totalFee > 10000">{{ (totalFee / 10000).toFixed(2) }}</span>
            <span v-else>{{ totalFee }}</span>
            <span v-if="totalFee > 10000">万</span>元
          </div>
        </div>
      </div>
      <orderList ref="list" @changeYindao="changeYindao" :isOrder="activeIndex == 1" @setListParams="setListParams"
        @listCallback="listCallback">
      </orderList>
      <!-- 日期选择弹窗 -->
      <datePopup ref="datePanel" dateType="date" @submit="selectDate"></datePopup>
    </van-pull-refresh>
    <!-- 引导分享 -->
    <div class="yindao" v-if="showYindao" @click="showYindao = false"></div>
  </div>
</template>

<script>
import orderList from "./components/list";
import datePopup from "@/components/tools/datePopup";
import { pageTools, common } from "@/api/mixins";
import searchInput from "./components/searchInput";
export default {
  mixins: [pageTools, common],
  components: { datePopup, orderList, searchInput },
  data() {
    return {
      typeId: "",
      showYindao: false,
      typeList1: [
        { name: "全部", id: "" },
        { name: "未支付", id: "1" },
        { name: "人核中", id: "2" },
        { name: "核保失败", id: "3" },
        { name: "已撤单", id: "4" },
        // { name: "需质检", id: "7" },
      ],
      typeList2: [
        { name: "全部", id: "" },
        { name: "已承保", id: "5" },
        { name: "已终止", id: "6" },
        // { name: "需质检", id: "8" },
      ],
      showSelectPanel: false,//账户类型弹窗
      type: "1",
      typeName: "全部账户",
      name: "",//投/被人姓名
      startTime: "",
      endTime: "",
      incomes: "",//服务费
      totalFee: "",//保费
      ordersNum: "",//订单数
      activeIndex: 1,
      list: [],
      isLoading: false,
    };
  },
  activated() {
    sessionStorage.appSearchOrderName = ''
  },
  mounted() {
    if (!this.checkLogin()) {
      return;
    }
    if (this.$route.query.type) {
      this.activeIndex = "";
    }
    if (sessionStorage.appOrderTab) {
      this.activeIndex = sessionStorage.appOrderTab * 1;
    }
    if (sessionStorage.appOrderTab2) {
      this.typeId = sessionStorage.appOrderTab2 * 1;
    }
    if (sessionStorage.appOrderName) {
      this.name = sessionStorage.appOrderName;
    }
    // 查询订单列表
    this.$refs.datePanel.init("date");
    this.$weixin.hideMenu();
  },
  methods: {
    goSearch() {
      sessionStorage.searchVal = '';
      if (this.$config.isApp) {
        this.$app.openWeb(location.origin + `/apps/order/search?nameType=3`);
      } else {
        this.$router.push({
          path: '/apps/order/search',
          query: {
            nameType: 3
          }
        });
      }
    },
    changeYindao() {
      this.showYindao = !this.showYindao;
    },
    listCallback(res) {
      this.list = res.data;
    },
    onRefresh() {
      this.isLoading = false;
      this.$refs.list.searchAjax();
      this.getOrderFeeData();
    },
    //设置产品参数
    setListParams(params) {
      if (this.activeIndex) {
        params.status = this.typeId ? this.activeIndex : '';
      }
      params.secondTab = this.typeId;
      params.auditOrder = 1;
      params.isNotPolicy = 1;
      params.startTime = this.startTime
      params.endTime = this.endTime
      return params
    },
    // 获取订单统计数据
    getOrderFeeData() {
      this.$http({
        type: "POST",
        url: "/api/order/statistics",
        data: this.setListParams({})
      }).then(res => {
        this.ordersNum = res.data.ordersNum;
        this.totalFee = res.data.totalFee;
        this.incomes = res.data.incomes;
      })
    },
    // 选择时间
    selectDate(date) {
      console.log("selectDate", date)
      this.startTime = date[0];
      this.endTime = date[1];
      // 初始化列表
      this.$refs.list.init("/api/order/queryMyOrders");
      // 获取统计数据
      this.getOrderFeeData();
    },
    // 列表跳转
    goPage(url, params, e) {
      if (e.target.className.indexOf("copy") != -1) {
        return;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    tabClick() {
      sessionStorage.appOrderTab = this.activeIndex;
      this.list = [];
      this.typeId = "";
      this.$refs.list.searchAjax();
      this.getOrderFeeData();
    },
    clickTypeLevel2(id) {
      this.list = [];
      this.typeId = id;
      this.$refs.list.searchAjax();
      this.getOrderFeeData();
    },
  },

};
</script>

<style lang="scss" scoped>@import "./list";</style>
